import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface AuthState {
  accessToken: string | null
  refreshToken: string | null
  userId: string | null
  isAuthenticated: boolean

  setTokens: (access: string, refresh: string) => void
  setUserId: (id: string) => void
  logout: () => void
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      accessToken: null,
      refreshToken: null,
      userId: null,
      isAuthenticated: false,

      setTokens: (access, refresh) => {
        localStorage.setItem('access_token', access)
        localStorage.setItem('refresh_token', refresh)
        set({ accessToken: access, refreshToken: refresh, isAuthenticated: true })
      },

      setUserId: (id) => set({ userId: id }),

      logout: () => {
        localStorage.removeItem('access_token')
        localStorage.removeItem('refresh_token')
        set({ accessToken: null, refreshToken: null, userId: null, isAuthenticated: false })
      },
    }),
    {
      name: 'auth-store',
      partialize: (s) => ({
        userId: s.userId,
        isAuthenticated: s.isAuthenticated,
        accessToken: s.accessToken,
        refreshToken: s.refreshToken,
      }),
      // Если старый auth-store не содержал токенов — читаем из localStorage напрямую
      merge: (persisted, current) => {
        const p = persisted as Partial<AuthState>
        return {
          ...current,
          ...p,
          accessToken: p.accessToken ?? localStorage.getItem('access_token'),
          refreshToken: p.refreshToken ?? localStorage.getItem('refresh_token'),
        }
      },
    },
  ),
)
